import moment from 'moment';
import {
  FactSliderModalController
} from './slider/facts-slider-modal.component';
import {
  setShowSystemKeys,
  getTableViewByType
} from './table-view';
import {
  WSPLITTER,
  IS_IE_BROWSER,
  PATH_STRING_SEPARATOR,
} from '../common/config';

require('./facts.component.scss');

// /* global gettext */

class FactsController {
  constructor(
    $scope,
    $timeout,
    $element,
    AudioWavesService,
    AudioService,
    AudioViewerService,
    $modal,
    RouterService,
    FieldsModalService,
    LayoutService,
    CurrentModelService,
    CurrentFilterService,
    LocalStorageService,
    FilterDataFactory,
  ) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    $scope.generateReport = RouterService.generateReport.bind(RouterService);
    $scope.isCollapsed = true;
    $scope.router = RouterService;
    $scope.LocalStorageService = LocalStorageService;
    this.model = CurrentModelService.model;
    this.dims = this.model._dimensions;
    this.FieldsModalService = FieldsModalService;
    this.CurrentFilterService = CurrentFilterService;
    $scope.setShowSystemKeys = setShowSystemKeys;
    this.FilterDataFactory = FilterDataFactory;
    $scope.imagesData = this.FilterDataFactory();
    $scope.LayoutService = LayoutService;
    $scope.selectedFact = $scope.filterData.filterData &&
      $scope.filterData.filterData.length ? $scope.filterData.filterData[0] : null;
    if ($scope.selectedFact) {
      $scope.selectedFact.selected = true;
    }
    const setSplitter = () => {
      $scope.splitter = {
        pos: $scope.LayoutService.options.isVerticalViewer.value ? $scope.LayoutService.splitters[2] : WSPLITTER,
        orient: $scope.LayoutService.options.isVerticalViewer.value ? 'horizontal' : 'vertical',
      };
    };
    setSplitter();
    $scope.$on('optionsChanged', () => {
      setSplitter();
      $timeout(() => {
        if ($scope.LayoutService.options.isVerticalViewer.value) {
          $scope.panel1 = $element.find('.split-pane1');
          $scope.panel2 = $element.find('.split-pane2');
        }
      }, 2000);
      setShowSystemKeys(this.$scope.LayoutService.options);
    });
    $scope.$on('splitter1Changed', () => {
      if ($scope.LayoutService.options.isVerticalViewer.value) {
        if (!$scope.panel1) $scope.panel1 = $element.find('.split-pane1');
        if (!$scope.panel2) $scope.panel2 = $element.find('.split-pane2');
        $scope.panel2.width(`calc(100% - ${$scope.panel1.width()}px`);
      }
    });

    this.$scope.$on('splitter3Mouseup', (e, d1, d2, name) => {
      $scope.LayoutService.splitters[2] = d1;
    });

    $scope.getCurrentColWidth = i => {
      return $scope.LayoutService.viewMode.currentColWidth ? $scope.LayoutService.viewMode.currentColWidth[i] : 100;
    };
    AudioService.loadNextAudio = () => {
      const nextFact = $scope.getNextAudio({
        select: false
      });
      if (AudioViewerService.isWaves(nextFact)) return;
      if (nextFact && nextFact.audio && !nextFact.audioLoad) {
        nextFact.audio.load();
        nextFact.audioLoad = true;
      }
    };

    AudioService.playNextAudio = () => {
      const nextFact = $scope.getNextAudio({
        select: true
      });
      if (AudioViewerService.isWaves(nextFact)) AudioWavesService.playAudio(nextFact);
      else AudioService.playAudio(nextFact);
    };

    AudioWavesService.playNextAudio = (previousPlayedFact) => {
      if (previousPlayedFact === this.previousPlayedFact) return;
      this.previousPlayedFact = previousPlayedFact;
      const nextFact = $scope.getNextAudio({
        select: true
      });
      if (AudioViewerService.isWaves(nextFact)) AudioWavesService.playAudio(nextFact);
      else AudioService.playAudio(nextFact);
    };

    AudioViewerService.playNextAudio = (previousPlayedFact) => {
      if (previousPlayedFact === this.previousPlayedFact) return;
      this.previousPlayedFact = previousPlayedFact;
      const nextFact = $scope.getNextAudio({
        select: true
      });
      AudioViewerService.play(nextFact);
    };

    $scope.$on('wavesurferReady', (e, fact, isCreated) => {
      if (isCreated && fact.selected) {
        // $scope.selectedFact = fact;
      }
    });

    $scope.showSelectFields = () => this.CurrentFilterService &&
      this.CurrentFilterService.filter &&
      !this.CurrentFilterService.filter.isDashboard && !this.CurrentFilterService.filter.isCard;

    $scope.selectFields = settingKey => {
      return this.FieldsModalService.open('TABLE', settingKey)
        .then(r => {
          if (r) this.$timeout(() => {
            $scope.filterData.filterData = angular.copy($scope.filterData.filterData);
            this.$timeout(() => $scope.$root.$broadcast('resize'), 0);
            $scope.tableSettingsKeys = Object.keys($scope.LocalStorageService.getTableSettings());
          }, 200);
        });
    };

    $scope.getNextAudio = ({
      select
    }) => {
      let eventIndex = $scope.getEventIndex();
      while (eventIndex < $scope.filterData.filterData.length && eventIndex >= 0) {
        eventIndex += 1;
        if (eventIndex + 1 >= $scope.filterData.filterData.length) {
          $scope.more();
        }
        if (eventIndex >= 0) {
          const fact = $scope.filterData.filterData[eventIndex];
          if (fact && fact['agent_eventtype.id'] === 21) {
            if (select) {
              $scope.select(fact);
              $scope.$apply();
            }
            return fact;
          }
        }
      }
    };

    $scope.select = function(fact) {
      if (fact === $scope.selectedFact) return;
      if ($scope.selectedFact) {
        $scope.selectedFact.selected = false;
      }
      $scope.selectedFact = fact;
      fact.selected = true;
      const position1 = $element.find('#tr' + fact.id).position() || 0;
      const eventTable = $element.find('.fact-table-tbody');
      const current = eventTable.scrollTop();
      const tbody_height = eventTable.height();
      eventTable.animate({
        scrollTop: current + position1.top -
          tbody_height / 3,
      }, 100);
      $scope.$broadcast('showPane2');
    };

    $scope.deselect = () => {
      if ($scope.selectedFact) {
        $scope.selectedFact = null;
        $scope.$broadcast('hidePane2');
        $scope.$apply();
      }
    };

    $scope.leaf = step => {
      let eventIndex = $scope.getEventIndex();
      if (eventIndex + step >= $scope.filterData.filterData.length) {
        $scope.more();
      } else {
        eventIndex += step;
        if (eventIndex < 0) eventIndex = 0;
        const fact = $scope.filterData.filterData[eventIndex];
        $scope.select(fact);
        $scope.$apply();
      }
    };
    $scope.getEventIndex = () => $scope.selectedFact ?
      $scope.filterData.filterData.findIndex(f => $scope.selectedFact.id === f.id) : 0;

    $scope.leafToLast = () => {
      const moveTo = $scope.filterData.filterData && $scope.filterData.filterData.length ?
        $scope.filterData.filterData[$scope.filterData.filterData.length - 1] : null;
      if (moveTo) {
        $scope.select(moveTo);
        $scope.$apply();
      }
    };
    $scope.leafToFirst = () => {
      const moveTo = $scope.filterData.filterData &&
        $scope.filterData.filterData.length ?
        $scope.filterData.filterData[0] : null;
      if (moveTo) {
        $scope.select(moveTo);
        $scope.$apply();
      }
    };

    $scope.toUserNearestScreenshot = fact => {
      const dateFact = moment(fact.local_time.substr(0, 19));
      if (!dateFact.isValid()) return;
      const timeFrom = moment(dateFact).subtract(1, 'hour');
      const timeTo = moment(dateFact).add(1, 'hour');
      const filters = [{
        'dimension': 'agent_eventtype@default:agent_eventtype',
        'value': '4',
        'label': gettext('Снимок экрана'),
        'predicates': []
      }];

      if (fact['agent_agent.id'] && fact['agent_agent.guid'] && fact['agent_agent.computer_name']) {
        filters.push({
          'dimension': 'agent_agent@computer_name:computer_name',
          'value': fact['agent_agent.id'] + PATH_STRING_SEPARATOR +
            fact['agent_agent.guid'] + PATH_STRING_SEPARATOR +
            fact['agent_agent.computer_name'],
          'label': fact['agent_agent.computer_name'],
          'predicates': []
        });
      }
      if (fact['agent_account.user_name']) {
        filters.push({
          'dimension': 'agent_account@user_name:user_name',
          'value': fact['agent_account.user_name'],
          'label': fact['agent_account.user_name'],
          'predicates': []
        });
      }

      const limit = 600;
      if (!$scope.imagesData) return;
      const imagesFilter = angular.copy(this.CurrentFilterService.filter);
      imagesFilter.customLimit = limit;
      imagesFilter.filters = filters;
      imagesFilter.hasOwnTime = true;
      imagesFilter.timeFrom = timeFrom;
      imagesFilter.timeTo = timeTo;

      this.needToShowImage = true;
      if (!$scope.imagesData.filter || $scope.imagesData.filterData == null ||
        ($scope.imagesData.filter && !angular.equals($scope.imagesData.filter, imagesFilter))) {
        $scope.LayoutService.loading = true;
        $scope.imagesData.update(imagesFilter, true);
      } else {
        $scope.$root.$broadcast('factsLoaded');
      }
    };

    const addCut = (cuts, dimension, value) => {
      let hasEeventtype = false;
      const noNeedAdd = cuts.some(f => {
        if (f.dimension === dimension)
          hasEeventtype = true;
        return (f.dimension === dimension && f.value == value);
      });
      if (hasEeventtype && !noNeedAdd) {
        cuts.push({
          'predicates': [
            '@'
          ],
          'dimension': dimension,
          'value': value,
        });
      }
    };


    const setImageViewerFilters = (filter, fact, factId) => {
      const groupHash = 'some_uniq_hash_bdslgdf434ggkwerelkarbvbdfgfgphoshs3';
      const query = {
        'operator': 'AND',
        'rules': [{
          group: {
            groupHash,
            'operator': 'OR',
            'rules': [{
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/jpeg',
                'label': 'image/jpeg'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/png',
                'label': 'image/png'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/bmp',
                'label': 'image/bmp'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/x-ms-bmp',
                'label': 'image/x-ms-bmp'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/gif',
                'label': 'image/gif'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/svg+xml',
                'label': 'image/svg+xml'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/vnd.microsoft.icon',
                'label': 'image/vnd.microsoft.icon'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/tiff',
                'label': 'image/tiff'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/emf',
                'label': 'image/emf'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'image/x-dds',
                'label': 'image/x-dds'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'video/mp4',
                'label': 'video/mp4'
              },
              {
                'condition': '=',
                'dimension': 'agent_attachedfile',
                'hierarchy': 'mime',
                'value': 'vnc/stream',
                'label': 'vnc/stream'
              },
              {
                'condition': '=',
                'dimension': 'id',
                'hierarchy': 'default',
                'value': factId.toString(),
                'label': 'factId'
              }
            ]
          }
        }]
      };

      if (filter.query && filter.query.rules && filter.query.rules.length) {
        if (filter.query.operator === 'AND' &&
          filter.query.rules.some(r => r.group && r.group.groupHash === groupHash))
          return true;
        const customGroup = Object.assign({}, filter.query);
        query.rules.splice(0, 0, {
          group: customGroup
        });
      }
      filter.query = query;
      if (fact.id !== factId && filter.filters && filter.filters.length) {
        const chFact = fact.children && fact.children.find(f => f.id === factId);
        if (chFact) {
          if ('agent_eventtype.id' in chFact) {
            const chTypeId = chFact['agent_eventtype.id'];
            addCut(filter.filters, 'agent_eventtype@default:agent_eventtype', String(chTypeId));
          }
          addCut(filter.filters, 'id@default:id', String(chFact.id));
        }
      }

      return false;
    };

    $scope.openImage = (fact, factId) => {
      if (!factId) factId =  fact.id;
      const imagesFilter = angular.copy(this.CurrentFilterService.filter);

      setImageViewerFilters(imagesFilter, fact, factId);
      this.imageFactId = factId;
      if (!$scope.imagesData) return;
      this.needToShowImage = true;
      if (!$scope.imagesData.filter || $scope.imagesData.filterData == null ||
        ($scope.imagesData.filter && !angular.equals($scope.imagesData.filter, imagesFilter) &&
          !$scope.imagesData.filterData.some(f => f.id === factId))) {
        $scope.LayoutService.loading = true;
        $scope.imagesData.update(imagesFilter, true);
      } else {
        $scope.$root.$broadcast('factsLoaded');
      }
    };

    $scope.$on('factsLoaded', () => {
      $scope.LayoutService.loading = false;
      if ($scope.LocalStorageService.getTableSettings)
        $scope.tableSettingsKeys = Object.keys($scope.LocalStorageService.getTableSettings());
      if (!this.needToShowImage || !$scope.imagesData || this.showImageOpened) return;
      const res = $scope.imagesData.filterData;
      if (res && res.length) {
        let fact = this.imageFactId && res.find(f => f.id == this.imageFactId);
        if (!fact) fact = res[0];
        $scope.showImage(fact);
      }
    });

    $scope.openFact = fact => {};

    $scope.showImage = fact => {
      if ($scope.router.isFilterEditModal) return;
      $scope.selectedImageFact = fact;
      if ($scope.imageDialog) {
        $scope.imageDialog.close();
      }
      if ($scope.router.imageDialog) {
        $scope.router.imageDialog.close();
      }
      if (this.timeoutAfterDialog) $timeout.cancel(this.timeoutAfterDialog);
      $scope.imageDialog = $modal.open({
        scope: $scope,
        template: require('./slider/facts-slider-modal.component.html'),
        controller: FactSliderModalController,
        windowClass: 'showImageModal',
      });
      $scope.imageDialog.opened.then(() => {
        this.showImageOpened = true;
      });

      $scope.router.CurrentFilterService.modal = null;
      $scope.router.imageDialog = $scope.imageDialog;

      $scope.imageDialog.result.finally(() => {
        this.showImageOpened = false;
        this.needToShowImage = false;
        $scope.router.removeModal();
        this.timeoutAfterDialog = this.$timeout(() => {
          $scope.imagesData.filterData = null;
        }, 1000 * 60 * 30);
      });

    };

    $scope.closeDialog = () => {
      if ($scope.imageDialog) {
        $scope.imageDialog.close();
      }
    };

    $scope.$on('col-resize', () => $scope.$digest());

    $scope.$watch('viewMode', newVal => {
      $scope.$broadcast('viewModeChanged', newVal);
    });

    const changeViewMode = () => {
      const filter = $scope.filter;
      if (filter) {
        const viewMode = getTableViewByType(
          filter.viewModeType(),
          filter.filters,
          filter.fields,
          this.dims
        );
        if (!$scope.LayoutService.viewMode || viewMode.columns.length !== $scope.LayoutService.viewMode.columns.length ||
          $scope.LayoutService.viewMode.columns.some((c, i) => c.factKey !== viewMode.columns[i].factKey)) {
          $scope.LayoutService.viewMode = viewMode;
        }
        $scope.viewMode = $scope.LayoutService.viewMode;
      }
      if (!$scope.filterData.filterData || !$scope.filterData.filterData.length || !$scope.selectedFact ||
        !~$scope.filterData.filterData.findIndex(f => f.id === $scope.selectedFact.id)) {
        $scope.selectedFact = null;
      }
      if (!$scope.selectedFact) {
        $scope.$broadcast('hidePane2');
      }
    };

    $scope.$watch('filterData.filterData', (newVal, oldVal) => {
      changeViewMode();
    }, false);

    $scope.updateElements = () => {
      $timeout(() => {
        $scope.$apply(() =>
          $timeout(() => {
            $scope.isUpdated = true;
          }, 50));
      }, 0);
    };

    $element.ready(() => {
      $timeout(() => {
        this.tableBody = this.$scope.listType === 'thumblist' ?
          $element.find('#fact-thumbnail-container') : $element.find('.fact-table-tbody');
        $scope.updateElements();
        $scope.$on('colViewUpdated', function(e) {
          $scope.isUpdating = false;
          if (!$scope.isUpdated) $scope.updateElements();
        });

        this.tableBody.on('scroll', () => {
          $scope.isUpdated = false;
          $scope.updateElements();
        });
      }, 10);
    });

    const keyboardEvents = {
      13: function() {
        if ($scope.selectedFact['agent_eventtype.name'] === 'Screenshot') $scope.openImage(
          $scope.selectedFact
        );
        $scope.$apply();
      }, // Enter
      27: function() {}, // Esc
      32: function() {
        $scope.leaf(1);
      }, // Space
      33: function() {
        $scope.leaf(-5);
      }, // PgUp
      34: function() {
        $scope.leaf(5);
      }, // PgDown
      35: function() {
        $scope.leafToLast();
      }, // End
      36: function() {
        $scope.leafToFirst();
      }, // Home
      37: function() {
        $scope.leaf(-1, true);
      }, // Left
      38: function() {
        $scope.leaf(-1);
      }, // Up
      39: function() {
        $scope.leaf(1, true);
      }, // Right
      40: function() {
        $scope.leaf(1);
      } // Down
    };

    $scope.bindEvents = function() {
      $element.off('keydown').on('keydown', e => {
        const code = e.which;
        const listType = $scope.router.search().listType;
        if (code in keyboardEvents && listType !== 'thumblist') {
          keyboardEvents[code]();
          e.preventDefault();
        }
      });
    };

    Object.defineProperty($scope, 'listType', {
      get: () => $scope.filter.listType,
    });
    $scope.more = () => $scope.loadMore && $scope.filterData.moreFacts();
  }

  toggleSortOrder(col) {
    if (!col.sortable) return;
    const filter = this.$scope.filter;
    filter.orderDir = filter.orderDir === 'desc' ? 'asc' : 'desc';
    filter.order = col.factKey;
    this.$scope.router.filter = filter;
    // this.$scope.filterData.update(filter);
  }

  isColSorted(col) {
    if (!col.sortable) return false;
    const order = this.$scope.filter.order === 'record_count' ? 'local_time' : this.$scope.filter.order;
    return order === col.factKey;
  }

}

export function FactsComponent(
  $compile,
  $timeout,
  RouterService,
) {
  return {
    restrict: 'E',
    scope: {
      model: '<',
      filter: '<',
      filterData: '<',
      showFactsInfo: '<',
      loadMore: '<',
    },
    template: require('./facts.component.html'),
    controller: FactsController,
    controllerAs: '$ctrl',
    link: function(scope, element, attrs) {
      scope.setShowSystemKeys(scope.LayoutService.options);
      scope.$watch('filter.listType', (newVal, oldVal) => {
        scope.bindEvents();
        if (newVal === 'table') {
          element.find('.fact-table-tbody').focus();
        } else if (newVal === 'thumblist') {
          element.find('.fact-thumbnail-list').focus();
        }

        element.click('.widget-value', event => {
          let el = angular.element(event.target);
          if (el.prop('tagName').search(/^Z\d/) == 0) el = el.parent();
          const closestAttr = (elScope, attr) => {
            while (!elScope[attr] && elScope.$parent) {
              elScope = elScope.$parent;
            }
            return elScope[attr];
          };
          if (el.attr('data-key')) {
            scope.$apply(() => {
              const key = el.attr('data-key');
              if (key === 'agent_web@url:url') {
                return window.open(el.attr('data-value'));
              }
              if (key === 'id@default:id' || key === 'analytics_filter@name:name') {
                RouterService.setFilter(key,
                  el.attr('data-value'), el.attr('data-label')
                );
                return;
              }
              if (key === 'agent_application@window_title:window_title') {
                RouterService.setFilter(key,
                  el.attr('data-value'), el.attr('data-label')
                );
                return;
              }
              // todo when $compileProvider.debugInfoEnabled is set to false,
              // calling .scope() on a DOM node will return undefined
              // const elScope = el.scope().$parent;
              const fact = closestAttr(el.scope(), 'fact');
              const model = closestAttr(el.scope(), 'model');
              if (fact && model) {
                const filter = model.getCellFilter(key, fact);
                RouterService.drilldownFilter2(filter);
              }
              // RouterService.drilldownFilter(filter);
            });
          }
        });
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/facts.component.js